export class JourneyError extends Error {
  readonly title: string

  constructor(message: string, title: string) {
    super(message)
    this.name = 'JourneyError'
    this.title = title
  }
}
